<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>
    <p>{{data.description}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="onYesClick()">Sim</button>
</div>